import { object, string } from "yup";
import { useEffect, useState } from "react";

import Validations from "@helpers/validations";
import getColumns from "./misc/deco-column";
import useAxios from "@hooks/use-axios";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";
import { yupResolver } from "@hookform/resolvers/yup";

const defaultValues = {
    name  : "",
    desc  : "",
    status: ""
};

const usePlans = () => {
    const { platformId } = useParams();      
    const { getSearchParams } = useSearchParams();
    const [queryParams, setQueryParams] = useState({});
    const [modalConfig, setModalConfig] = useState({
        open: false,
        row : {}
    });

    const { requiredValidation } = Validations();

    const [data, setData] = useState({
        plans     : [],
        pagination: {
            total: 0,
            limit: 0,
            count: 0,
            page : 1
        }
    });

    const { axiosInstance, loading, cancelAllRequests } = useAxios({ base: "panel", initialLoader: true });
    const { axiosInstance: upsertAxiosInstance, loading: upsertLoading } = useAxios({ base: "panel" });

    const methods = useForm({
        defaultValues,
        resolver: yupResolver(object({
            name  : requiredValidation({ name: "Name" }),
            desc  : string(),
            status: requiredValidation({ name: "Status" })
        }))
    });

    const { reset, handleSubmit } = methods;

    const getAllPlans = async  () => {
        const { data } = await axiosInstance.get(`/plans/${platformId}`, {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });

        if (data) {
            setData(data);
        }
    };

    const toggleModal = (data = defaultValues) => {
        setModalConfig((prev) => ({ row: data, open: !prev.open }));
        reset(data);
    };

    const onSubmit = () => {
        handleSubmit(async (data) => {
            const payload = {
                name  : data.name,
                desc  : data.desc,
                status: data.status
            };

            if (!modalConfig.row._id) {
                await upsertAxiosInstance.post(`/plans/${platformId}`, payload);
            } else {
                await upsertAxiosInstance.patch(`/plans/${platformId}/${modalConfig.row._id}`, payload);
            }

            getAllPlans();
            toggleModal();
        })();
    };

    const handleRowActions = async (action, row) => {
        if (action === "delete") {
            await upsertAxiosInstance.delete(`/plans/${platformId}/${row._id}`);
            getAllPlans();
            return;
        }
        toggleModal(row);
    };

    useEffect(() => {
        let active = true;
        if (active) {
            getAllPlans();
        }

        return () => {
            active = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    const columns = getColumns({ handleRowActions });

    return {
        getAllPlans,
        loading,
        data,
        columns,
        setQueryParams,
        toggleModal,
        modalConfig,
        methods,
        upsertLoading,
        onSubmit
    };
};

export default usePlans;